import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { ARTICLES } from "@/data/content";

export function ArticleCard({ article }) {
  return (
    <Link
      to={`/blog/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group bg-white border border-slate-200 hover:shadow-xl transition-shadow duration-300 flex flex-col"
    >
      <div className="overflow-hidden aspect-[16/10]">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 text-xs">
          <span className="bg-emerald/10 text-emerald px-2.5 py-1 font-medium uppercase tracking-wider">{article.category}</span>
          <span className="text-slate-400">{article.date}</span>
        </div>
        <h3 className="font-display text-xl font-bold text-midnight mt-4 leading-snug group-hover:text-emerald transition-colors">{article.title}</h3>
        <p className="mt-3 text-sm text-slate-600 font-light leading-relaxed flex-1">{article.excerpt}</p>
        <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-midnight group-hover:text-emerald transition-colors">
          Lire l'article <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </span>
      </div>
    </Link>
  );
}

export default function BlogSection() {
  const featured = ARTICLES.slice(0, 3);
  return (
    <section id="blog" className="bg-slate-100 py-24 lg:py-32" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal>
            <Overline>Actualités</Overline>
            <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight max-w-2xl">
              Réglementation, CEE et efficacité énergétique
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/blog">
              <Button variant="outline" className="rounded-none border-midnight text-midnight hover:bg-midnight hover:text-white group" data-testid="blog-all-btn">
                Tous les articles <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {featured.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08}><ArticleCard article={a} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
